// extracted by mini-css-extract-plugin
export default {"companyLogo":"CompanyInformation_companyLogo__w6w+T","colorBlock":"CompanyInformation_colorBlock__97YjI"};